export default __webpack_public_path__ + "static/media/maisons_laffitte12.03a148bb.jpg";